<template>
  <div>
    <h1 class="text-3xl text-center uppercase mb-24">Wij hebben uw aanvraag ontvangen en nemen z.s.m. contact met u op.</h1>
  </div>
</template>

<script>
export default {
  name: 'Klaar'
};



</script>
